import { Provider } from 'react-redux';
import { store } from 'app/store/store';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from 'app/providers/theme/theme';
import AppRouter from 'app/routers/AppRouter';

function App() {
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <BrowserRouter basename={process.env.HOMEPAGE}>
                    <AppRouter />
                </BrowserRouter>
            </ThemeProvider>
        </Provider>
    )
}

export default App
